import { RuleConditionType } from './rule-conditions-type.enum';
import { RuleOperator } from './rule-operators-type.enum';
import { AssignTicketTypes } from './rule.i';
var RuleConditionBuilder = /** @class */ (function () {
    function RuleConditionBuilder() {
        this.condition = {
            type: RuleConditionType.TICKET_SUBJECT,
            operator: RuleOperator.IS,
            values: ['Test subject']
        };
    }
    RuleConditionBuilder.prototype.withType = function (type) {
        this.condition.type = type;
        return this;
    };
    RuleConditionBuilder.prototype.withOperator = function (operator) {
        switch (this.condition.type) {
            case RuleConditionType.UGC_ITEM_USER_AUTHENTICATED:
            case RuleConditionType.UGC_ITEM_COUNTRY:
            case RuleConditionType.UGC_ITEM_EVENT_TIME:
            case RuleConditionType.TICKET_STATUS:
            case RuleConditionType.TICKET_CHANNEL:
            case RuleConditionType.TICKET_PRIORITY:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_LABELS:
            case RuleConditionType.TICKET_RELATED_ARTICLES_CATEGORIES:
            case RuleConditionType.TICKET_RELATED_ARTICLES:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_ASSIGNED:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_BOOLEAN_CUSTOM_FIELD:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_TEXT_CUSTOM_FIELD:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_NUMBER_CUSTOM_FIELD:
                this.condition.operator = operator;
                break;
            case RuleConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD:
                this.condition.operator = operator;
                break;
            default:
                this.condition.operator = operator;
                break;
        }
        return this;
    };
    RuleConditionBuilder.prototype.withData = function (data, subCondition) {
        switch (this.condition.type) {
            case RuleConditionType.TICKET_SUBJECT:
            case RuleConditionType.TICKET_CONTENT:
            case RuleConditionType.REPLY_CONTENT:
            case RuleConditionType.UGC_ITEM_USER_NAME:
            case RuleConditionType.UGC_ITEM_USER_EMAIL:
            case RuleConditionType.UGC_ITEM_COUNTRY:
            case RuleConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD:
                this.condition.values = data;
                break;
            case RuleConditionType.TICKET_LOCALE:
                this.condition.locales = data;
                break;
            case RuleConditionType.TICKET_STATUS:
                this.condition.statuses = data;
                break;
            case RuleConditionType.TICKET_BRAND:
                this.condition.brandIds = data;
                break;
            case RuleConditionType.TICKET_CHANNEL:
                this.condition.channels = data;
                break;
            case RuleConditionType.TICKET_LABELS:
                this.condition.labelIds = data;
                break;
            case RuleConditionType.TICKET_RELATED_ARTICLES_CATEGORIES:
                this.condition.categoryIds = data;
                break;
            case RuleConditionType.TICKET_RELATED_ARTICLES:
                this.condition.articleIds = data;
                break;
            case RuleConditionType.TICKET_PRIORITY:
                this.condition.priorities = data;
                break;
            case RuleConditionType.TICKET_ASSIGNED:
                if (subCondition === AssignTicketTypes.USER) {
                    this.condition.assignedUserIds = data;
                    this.condition.assignedGroupIds = [];
                }
                else {
                    this.condition.assignedGroupIds = data;
                    this.condition.assignedUserIds = [];
                }
                break;
            case RuleConditionType.TICKET_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_BOOLEAN_CUSTOM_FIELD:
                this.condition.value = data;
                break;
            case RuleConditionType.TICKET_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_TEXT_CUSTOM_FIELD:
                this.condition.values = data;
                break;
            case RuleConditionType.TICKET_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_NUMBER_CUSTOM_FIELD:
                var numberData = data;
                this.condition.from = numberData.from;
                this.condition.to = numberData.to;
                break;
            default:
                break;
        }
        return this;
    };
    RuleConditionBuilder.prototype.withEventTimeData = function (fromDay, fromTime, toDay, toTime) {
        switch (this.condition.type) {
            case RuleConditionType.UGC_ITEM_EVENT_TIME:
                this.condition = {
                    fromDay: fromDay, fromTime: fromTime, toDay: toDay, toTime: toTime,
                    type: RuleConditionType.UGC_ITEM_EVENT_TIME,
                    operator: this.condition.operator
                };
                break;
            default:
                return this;
        }
        return this;
    };
    RuleConditionBuilder.prototype.withFieldName = function (fieldName) {
        switch (this.condition.type) {
            case RuleConditionType.TICKET_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_TEXT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleConditionType.TICKET_MULTI_LEVEL_CUSTOM_FIELD:
                this.condition.fieldName = fieldName;
                break;
            default:
                return this;
        }
        return this;
    };
    RuleConditionBuilder.prototype.build = function () {
        var condition = this.condition;
        switch (condition.type) {
            case RuleConditionType.TICKET_CHANNEL:
            case RuleConditionType.UGC_ITEM_USER_AUTHENTICATED:
            case RuleConditionType.UGC_ITEM_EVENT_TIME:
            case RuleConditionType.TICKET_LOCALE:
            case RuleConditionType.TICKET_STATUS:
            case RuleConditionType.TICKET_BRAND:
            case RuleConditionType.TICKET_LABELS:
            case RuleConditionType.TICKET_RELATED_ARTICLES_CATEGORIES:
            case RuleConditionType.TICKET_RELATED_ARTICLES:
            case RuleConditionType.TICKET_PRIORITY:
            case RuleConditionType.TICKET_ASSIGNED:
            case RuleConditionType.TICKET_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_BOOLEAN_CUSTOM_FIELD:
            case RuleConditionType.TICKET_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_USER_NUMBER_CUSTOM_FIELD:
            case RuleConditionType.TICKET_COMPANY_NUMBER_CUSTOM_FIELD:
                if (condition.values) {
                    delete condition.values;
                }
                return condition;
            default:
                return this.condition;
        }
    };
    return RuleConditionBuilder;
}());
export { RuleConditionBuilder };
//# sourceMappingURL=rule-condition.builder.js.map